import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    TextField,
    Dialog,
    Fade,
    MenuItem,
    FormControl,
    Select
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { FacebookShareButton, FacebookIcon, TwitterIcon, EmailIcon, TwitterShareButton, EmailShareButton } from 'react-share';
import { Share } from '@material-ui/icons';
import axios from 'axios';
import { getCookies } from '../../utils/getToken.js';
import { SERVER_URL } from '../../utils/config/constants.js';
import DateTimePanel from '../Booking/DateTimePanel.jsx';
import Dropzone from 'react-dropzone';
import { NotificationManager } from 'react-notifications';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});

var formData = new FormData()


class HelpList extends React.Component {
    constructor() {
        super();
    }
    state = {
        mainData: [],
        showAddMainDialog: false,
        category: "",
        notes: "",
        isImage: false,
        openDateTime: false,
        dateTimeValue: "",
        imageFiles: [],
        datasource: [],
        selectedCategory: ""


    }
    componentDidMount() {
        this.getMainLog();
    }
    getMainLog = () => {
        var authToken = getCookies();
        axios({
            method: 'get',
            url: `${SERVER_URL}/helpdesk/get`,
            headers: { 'x-auth-token': authToken }
        }).then((resJson) => {
            console.log("Resjsonnnn:::", resJson)
            if (resJson.data.status == "OK") {
                this.setState({
                    mainData: resJson.data.data.list,
                    datasource: resJson.data
                })
            } else {
                this.setState({
                    mainData: []
                })
            }
        })
    }
    closeDialog = () => {
        this.setState({
            showAddMainDialog: false,
            selectedCategory: "",
        })
    }
    addMainLog = () => {
        if (this.state.selectedCategory == "") {
            NotificationManager.error("Oops!", "Please select issue category")
        } else if (this.state.notes.trim() == "") {
            NotificationManager.error("Oops!", "Please describe your issue.")
        } else {
            var authToken = getCookies();
            axios({
                method: 'post',
                url: `${SERVER_URL}/helpdesk/add`,
                headers: { 'x-auth-token': authToken },
                data: {
                    category: this.state.selectedCategory,
                    description: this.state.notes
                }
            }).then((resJson) => {
                console.log("Resjsonnnn:::", resJson)
                if (resJson.data.status == "OK") {
                    NotificationManager.success("Success", resJson.data.message)
                    this.setState({
                        showAddMainDialog: false,
                        imageFiles: []
                    })
                    this.getMainLog()
                } else {
                    NotificationManager.error("Oops!", resJson.data.message)
                    this.setState({
                        showAddMainDialog: false,
                        imageFiles: []
                    })
                }
            })
        }
    }

    handleBusinessCategory = event => {
        this.setState({
            selectedCategory: event.target.value
        })
    }

    render() {
        return (
            <div className="md-12" style={{ width: "100%" }}>
                <div className="mt-1 md-12 mr-1" style={{ height: 40, justifyContent: "flex-end", display: "flex" }}>
                    <Button variant="contained" color="primary" style={{ width: 120 }} onClick={() => {
                        this.setState({
                            showAddMainDialog: true
                        })
                    }}> Add</Button>
                </div>
                <div className="md-12">
                    {this.state.mainData.length > 0 && this.state.mainData.map((item) => {
                        console.log("Item data", item.notes)
                        return (
                            <Paper className="m-2 p-2 ">
                                <div className="md-12 row">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }} ><p><b>Date:</b></p></div>
                                    <div className="d-flex col-md-8 " style={{ height: 30, alignItems: "center" }}><p>{moment(item.created_at).format('MM-DD-YYYY')}</p></div>
                                </div>
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Issue Type:</b></p></div>
                                    <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.category}</p></div>
                                </div>
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Description:</b></p></div>
                                    <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.description}</p></div>
                                </div>

                            </Paper>
                        )
                    })
                    }

                    {this.state.mainData.length == 0 &&
                        <Paper className="m-2 p-2 ">
                            <div className="md-12 row">
                                <div className="d-flex col-md-12" style={{ height: 30, alignItems: "center", justifyContent: "center" }} ><p><b>{this.state.datasource.message}</b></p></div>
                            </div>

                        </Paper>
                    }
                </div>
                {this.state.showAddMainDialog &&
                    <Dialog
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        className="service-suggestion-modal md-4 align-self-center"
                        open={this.state.showAddMainDialog}
                        onClose={this.closeDialog}
                        aria-labelledby="form-dialog-title"
                    >
                        <div style={{ backgroundColor: "white" }} className="col p-3">
                            <div className="col-md-12 mt-1">
                                <p>Select your issue category</p>
                                <Select style={{ marginLeft: -15 }}
                                    className="login-form-textfield md-12 form-control"
                                    autoWidth={true}
                                    value={this.state.selectedCategory}
                                    onChange={this.handleBusinessCategory}
                                    label="Select your issue category"
                                >
                                    {this.state.datasource.data.categoryData.map((category, index) => {
                                        return (
                                            <MenuItem
                                                value={index + 1}
                                                key={index}
                                            >
                                                {category.message}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>

                            </div>

                            <TextField id="standard-basic" className="login-form-textfield"
                            multiline={true}
                            rows={4}
                                style={{ marginTop: 15 }} label="Description" fullWidth onChange={event => {
                                    this.setState({
                                        notes: event.target.value,
                                    });
                                }} />
                            <button type="button" class="btn btn-primary btn-lg align-self-center mt-3"
                                onClick={() => {
                                    this.addMainLog()
                                }}>Submit</button>
                        </div>
                    </Dialog>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(HelpList);



// WEBPACK FOOTER //
// ./src/components/Customer/HelpList.jsx